export enum TipoValorEnum {
  Dolar = 'DOLAR',
  Porcentaje = 'PORCENTAJE',
}
